const constants = {
  PROPOSAL: 'Proposal',
  PROPOSALS: 'Proposals',
  SEGMENT: 'Segment',
  SEGMENTS: 'Segments',
};

Object.freeze(constants);

export function lower(str) {
  return str.toLowerCase();
}

export default constants;
